<template>
  <div></div>
</template>

<script>
  export default {
    name: 'ContractorsNotesTab',
  };
</script>
